module.exports = __webpack_public_path__ + "crm_static/img/14.874ef015.png";